import React, { Component } from 'react'
import { translations } from 'gipsy-misc'

import container from './container'
import AuthBackground from 'features/auth/components/background'
import { LoginButtons } from 'gipsy-ui'

class LoginPage extends Component {
  render() {
    const { goToGoogleAuth, goToMicrosoftAuth } = this.props
    return (
      <AuthBackground
        title={translations.auth.welcomeBack}
        linkText={translations.auth.newHere}
        linkTo="invite-request">
        <LoginButtons onGoogleLogin={goToGoogleAuth} onMicrosoftLogin={goToMicrosoftAuth} />
      </AuthBackground>
    )
  }
}

export default container(LoginPage)



// WEBPACK FOOTER //
// ./src/pages/login/index.js